import React from 'react';
import flowchart from '../image_dir/FLOWCHART.png';

/*
 * FlowchartSection introduces the reader to the workings of the
 * application.  A heading precedes the imported flowchart image.  The
 * image is responsive and scales to the width of its container.
 */
function FlowchartSection() {
  return (
    <section className="flowchart-section">
      <div className="flowchart-container">
        <h2>Come funziona:</h2>
        <img
          src={flowchart}
          alt="Diagramma di funzionamento"
          className="flowchart"
        />
      </div>
    </section>
  );
}

export default FlowchartSection;